import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import history from './history';
import './App.css';
import Login from './auth_components/js/Login';
import HomePage from './Containers/HomePage';

import InitialisationContainer from './Containers/InitialisationContainer';

import MasterContainer from './Containers/MasterContainer';

import SettingsContainer from './Containers/SettingsContainer';

import LogContainer from './Containers/LogContainer';
import AddNewContainerMain from './Containers/AddNewContainerMain';
import ViewAllContainer from './Containers/ViewAllContainer';
import CourseOutcomeContainer from './Containers/CourseOutcomeContainer';
import EmployeeContainer from './Containers/EmployeeContainer';
import IqacNewContainer from './Containers/IqacNewContainer';
import ITEPNewContainer from './Containers/ITEPNewContainer';
import LibraryNewContainer from './Containers/LibraryNewContainer';
import UnitCellNewContainer from './Containers/UnitCellNewContainer';
import GalleryPhotoContainer from './Containers/GalleryPhotoContainer';
import GalleryAwardContainer from './Containers/GalleryAwardContainer';
import HomeBannerContainer from './Containers/HomeBannerContainer';
import ProgrammeNewContainer from './Containers/ProgrammeNewContainer';
import DepartmentHomeLanding from './Containers/DepartmentHomeLanding';
import FacultyHomeLanding from './Containers/FacultyHomeLanding';



class App extends Component {
  render() {
    return (
      <Router history={history} >

        <div>
          <Switch>
            <Route path="/login" component={Login} />
            <Route exact path="/" component={HomePage} />

            <Route exact path="/initialisation" component={InitialisationContainer} />
            <Route exact path="/settings" component={SettingsContainer} />
            <Route exact path="/courseoutcome/add" component={AddNewContainerMain} />
            <Route exact path="/courseoutcome/edit" component={AddNewContainerMain} />
            <Route exact path="/courseoutcome/view" component={AddNewContainerMain} />

            <Route exact path="/activity/add" component={AddNewContainerMain} />
            <Route exact path="/activity/edit" component={AddNewContainerMain} />
            <Route exact path="/activity/view" component={AddNewContainerMain} />

            <Route exact path="/facility/add" component={AddNewContainerMain} />
            <Route exact path="/facility/edit" component={AddNewContainerMain} />
            <Route exact path="/facility/view" component={AddNewContainerMain} />

            <Route exact path="/filegroup/add" component={AddNewContainerMain} />
            <Route exact path="/filegroup/edit" component={AddNewContainerMain} />
            <Route exact path="/filegroup/view" component={AddNewContainerMain} />

            <Route exact path="/filegroupitem/add" component={AddNewContainerMain} />
            <Route exact path="/filegroupitem/edit" component={AddNewContainerMain} />
            <Route exact path="/filegroupitem/view" component={AddNewContainerMain} />


            <Route exact path="/notices" component={AddNewContainerMain} />
            <Route exact path="/tender" component={AddNewContainerMain} />
            <Route exact path="/news" component={AddNewContainerMain} />
            <Route exact path="/events" component={AddNewContainerMain} />
            <Route exact path="/edit" component={AddNewContainerMain} />
            <Route exact path="/view" component={ViewAllContainer} />

            <Route exact path="/featured-notification" component={AddNewContainerMain} />
            <Route exact path="/featured-notification/add" component={AddNewContainerMain} />
            <Route exact path="/featured-notification/edit" component={AddNewContainerMain} />

            <Route exact path="/master/course" component={MasterContainer} />
            <Route exact path="/master/department" component={MasterContainer} />
            <Route exact path="/master/subject" component={MasterContainer} />
            <Route exact path="/master/stream" component={MasterContainer} />
            <Route exact path="/master/session" component={MasterContainer} />
            <Route exact path="/master/leave" component={MasterContainer} />
            <Route exact path="/master/class" component={MasterContainer} />
            <Route exact path="/master/routine" component={MasterContainer} />
            <Route exact path="/master/section" component={MasterContainer} />
            <Route exact path="/master/access" component={MasterContainer} />
            <Route exact path="/master/doctype" component={MasterContainer} />
            <Route exact path="/master/passwordchange" component={MasterContainer} />

            <Route exact path="/department/:dept_code/:link" component={DepartmentHomeLanding} />
            <Route exact path="/faculty/:employee_id/:link" component={FacultyHomeLanding} />



            <Route exact path="/employee" component={EmployeeContainer} />  




            <Route exact path="/logs" component={LogContainer} />
            <Route exact path="/iqac-new" component={IqacNewContainer} />
            <Route exact path="/itep" component={ITEPNewContainer} />
            <Route exact path="/library" component={LibraryNewContainer} />
            <Route exact path="/unitcell" component={UnitCellNewContainer} />
            <Route exact path="/gallery-photo" component={GalleryPhotoContainer} />
            <Route exact path="/gallery-award" component={GalleryAwardContainer} />
            <Route exact path="/home-banner" component={HomeBannerContainer} />
            <Route exact path="/programmes" component={ProgrammeNewContainer} />



          </Switch>
        </div>

      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js